

import axios from 'axios'
import store from '@/store/store.js'
import { Message } from 'element-ui'
import router from '../router/index'
import isCommon from "@/utils/common.js";
// import {jwtToken} from "./tools"

// axios.defaults.withCredentials=true;
const instance = axios.create({
    baseURL: process.env.ENV === 'production' ? process.env.VUE_APP_REQUEST_URL : '/api',  //配置过的代理   //这里配置完在api里请求时就不需要加代理覆写的写法了，只需要写变化的路由即可
    timeout:165000,  //请求时长过长时终止请求
    // withCredentials : true, //允许携带cookie
    headers: {
        'Access-Control-Allow-Origin': '*',
        'X-Requested-With': 'XMLHttpRequest',
        "Content-Type": "application/json",
        'Cache-Control': 'no-cache'
        // get: {
        //   // 设置默认请求头，当需要特殊请求头时，将其作为参数传入，即可覆盖此处的默认参数
          
        // },
        // post: {
        //   // 设置默认请求头，当需要特殊请求头时，将其作为参数传入，即可覆盖此处的默认参数(第三个参数即config)
        //   // 例如：
        //   //     services.post(`${base.lkBaseURL}/uploads/singleFileUpload`, file, {
        //   //       headers: { "Content-Type": "multipart/form-data" }
        //   //     });
        //   "Content-Type": "application/json;charset=utf-8"
        //  }
       }
})

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
    // 从vuex里获取token
   const token = store.state.token;
   // 如果token存在就在请求头里添加
   if (token) {
    config.headers.Authorization = token
   }
  //  token && (config.headers.Authorization = token);
    return config;
  }, function (error) {
    // 对请求错误做些什么
    Message.error("服务器出错");
    return Promise.reject(error);
  });


  // 添加响应拦截器
instance.interceptors.response.use((response) => {
  console.log(111);
    // 对响应数据做点什么
    const res = response.data //后台返回的数据结构
    if (typeof res === 'string' && res.includes('<!DOCTYPE html>')) {
      router.push('/404')
      return
    }
     // 判断头部是否有token  && response.headers['Authorization']!=='undefined'
    if ('authorization' in response.headers) {
      // token过期时后端会这样返回?
      store.commit('setToken',response.headers.authorization); 
    }
    if (res.code === 20000||res.type==='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        // 复位token
        isCommon.TokenInvalidFlag = 0;
        return Promise.resolve(res)
    }else if (res.code === 4001) {
      if(isCommon.TokenInvalidFlag === 0) {
        // token失效了
        isCommon.TokenInvalidFlag = 1;
        Message.error('token失效，请重新登录！')
        store.commit('removeToken');
        setTimeout(() => {
            router.push('/login')
        }, 2000)
    }
    } else if (res.code === 4003) {
      Message.warning("无权限")
        router.push('/NoPermission')
    } 
    else {  //todo
        return Promise.reject(res)
    }
  }, (error) => {    
    // 对响应错误做点什么
    if (error.response.status === 4001) {
        if(isCommon.TokenInvalidFlag === 0) {
            // token失效了
            isCommon.TokenInvalidFlag = 1;
            Message.error('token失效，请重新登录！')
            store.commit('removeToken');
            setTimeout(() => {
                router.push('/login')
            }, 2000)
        }
      }else if (error.response.status === 4003) {
        //   无权限
        Message.warning("无权限")
        router.push('/NoPermission')

        // store.commit('removeToken');  //清除store里的token
        // setTimeout(() => {
        //   router.push('/login')
        //   }, 2000)
      } else {
        if (!window.navigator.onLine) {
            Message.warning('网络异常，请检查网络是否正常连接')
        } else if (error.code === 'ECONNABORTED') {
            Message.warning('请求超时')
        } else {
            Message.warning('服务器异常，请联系管理员')
        }
      }
    return Promise.reject(error.response);
  });


  export default instance